import * as React from "react";
import { RiEyeLine, RiEyeOffLine } from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";

import axiosInstance from "../../Api/Axios";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

const initialFormState = {
  operation: "update_password",
  old_password: "",
  password: "",
  password_confirmation: "",
};

const UserPassword = ({ setActiveSendOtp }) => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessage, setFormErrorMessage] = React.useState("");
  const [isVisibleOldPassword, setIsVisibleOldPassword] = React.useState(false);
  const [isVisiblePassword, setIsVisiblePassword] = React.useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    React.useState(false);

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (e, key) => {
    setFormErrorMessage((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/client/send-otp`, {
        old_password: valRegister.old_password,
        password: valRegister.password,
        password_confirmation: valRegister.password_confirmation,
        operation: valRegister.operation,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          setActiveSendOtp(false);
          localStorage.removeItem("key_op");
          localStorage.setItem("key_op", response.data.data.keyOp);
          addToast({
            variant: "success",
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessage(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.data || error.response.data.message,
          });
        }
      });
  };

  const ShowOldPassword = () => {
    setIsVisibleOldPassword((prev) => !prev);
  };
  const ShowPassword = () => {
    setIsVisiblePassword((prev) => !prev);
  };

  const ShowConfirmPassword = () => {
    setIsVisibleConfirmPassword((prev) => !prev);
  };
  return (
    <div>
      <h1>Modifier mot de passe</h1>
      <p>Veuillez remplir les champs ci dessous</p>
      <form className="register-form" onSubmit={handleSubmit} noValidate>
        <Textfield
          autoComplete="off"
          label="Ancien Mot de passe"
          name="password"
          type={isVisibleOldPassword ? "text" : "password"}
          placeholder="Veuillez insérer votre mot de passe"
          size="large"
          value={valRegister.old_password}
          onChange={(e) => handleChangeField(e, "old_password")}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
          onPaste={(e) => e.preventDefault()}
          rightIcon={
            isVisibleOldPassword ? (
              <RiEyeLine onClick={ShowOldPassword} />
            ) : (
              <RiEyeOffLine onClick={ShowOldPassword} />
            )
          }
          hasError={formErrorMessage.old_password}
          errorMessage={
            formErrorMessage.old_password && (
              <div className="text-danger">{formErrorMessage.old_password}</div>
            )
          }
        />
        <Textfield
          autoComplete="off"
          label="Nouveau mot de passe"
          name="password"
          type={isVisiblePassword ? "text" : "password"}
          placeholder="Veuillez insérer votre mot de passe"
          size="large"
          value={valRegister.password}
          onChange={(e) => handleChangeField(e, "password")}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
          onPaste={(e) => e.preventDefault()}
          rightIcon={
            isVisiblePassword ? (
              <RiEyeLine onClick={ShowPassword} />
            ) : (
              <RiEyeOffLine onClick={ShowPassword} />
            )
          }
          hasError={formErrorMessage.password}
          errorMessage={
            formErrorMessage.password && (
              <div className="text-danger">{formErrorMessage.password}</div>
            )
          }
        />
        <Textfield
          autoComplete="off"
          label="Confirmer nouveau mot de passe"
          name="password_confirmation"
          type={isVisibleConfirmPassword ? "text" : "password"}
          placeholder="Veuillez confirmer votre mot de passe"
          size="large"
          value={valRegister.password_confirmation}
          onChange={(e) => handleChangeField(e, "password_confirmation")}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
          onPaste={(e) => e.preventDefault()}
          rightIcon={
            isVisibleConfirmPassword ? (
              <RiEyeLine onClick={ShowConfirmPassword} />
            ) : (
              <RiEyeOffLine onClick={ShowConfirmPassword} />
            )
          }
          hasError={formErrorMessage.password_confirmation}
          errorMessage={
            formErrorMessage.password_confirmation && (
              <div className="text-danger">
                {formErrorMessage.password_confirmation}
              </div>
            )
          }
        />

        <div className="wrap_actions_form">
          <Button type="submit" size="lg">
            Modifier
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UserPassword;
